import { Injectable, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
Bootstrap described toaster system.
See https://ng-bootstrap.github.io/#/components/toast/examples
*/
@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private _tranlateService: TranslateService) {}
  toasts: any[] = [];

  showSuccess(toastContent: string, interpolateParams?: Object) {
    this._show(this._tranlateService.instant(toastContent, interpolateParams), {
      classname: 'bg-success text-light',
      delay: 3000,
    });
  }

  showDanger(toastContent: string, interpolateParams?: Object) {
    this._show(this._tranlateService.instant(toastContent, interpolateParams), {
      classname: 'bg-danger text-light',
      delay: 5000,
    });
  }

  _show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }
}
